import React, { useState } from "react";
import Card from "@mui/material/Card";
import { TextareaAutosize } from "@mui/base";
import SearchDropDownListPaginationComponent from "../../../Components/casp/common/SearchDropDownPaginationList";
import { AllPriorityList } from "../../../api/casp/priority";
import * as Yup from "yup";
import { useFormik } from "formik";
import { MemberIcon } from "../../../constants/MemberIcon";
import TextEditor from "../../../Components/casp/common/TextEditor";
import { Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { changeRequestUpdate } from "../../../api/casp/changeRequest";
import { withTranslation } from "react-i18next";
import { getUrl } from "../../../helpers/file_helper";
import UserProfile from "../common/userProfile";

const ChangeRequestMeta = (props) =>{
  const [isLoading, setIsLoading] = useState(false);
  const [newChangeRequestObject, setNewChangeRequestObject] = useState({
    description: props?.setChangeRequestMetaInfo.description,
    reason: props?.setChangeRequestMetaInfo.reason,
    impact: props?.setChangeRequestMetaInfo.impact,
    comments: props?.setChangeRequestMetaInfo.comments,
    negativeImpact: props?.setChangeRequestMetaInfo.negativeImpact,
    priority: {
      id: props.setChangeRequestMetaInfo?.priority.id,
      label: props.setChangeRequestMetaInfo?.priority.name,
      key: `${props.setChangeRequestMetaInfo?.priority.id}|${props.setChangeRequestMetaInfo?.priority.name}`,
    },
  });

  const changeRequestValidation = Yup.object().shape({
    description: Yup.string()
      .strict(true)
      .trim(props.t('Must not include leading and trailing spaces'))
      .min(2, props.t("Too Short!"))
      .max(2000, props.t("Too Long!"))
      .required(props.t("Please enter description")),
    reason: Yup.string()
      .strict(true)
      .trim(props.t('Must not include leading and trailing spaces'))
      .min(2, props.t("Too Short!"))
      .max(2000, props.t("Too Long!"))
      .required(props.t("Please enter reason")),
    impact: Yup.string()
      .strict(true)
      .trim(props.t('Must not include leading and trailing spaces'))
      .min(2, props.t("Too Short!"))
      .max(2000, props.t("Too Long!"))
      .required(props.t("Please enter impact")),
    negativeImpact: Yup.string()
      .strict(true)
      .trim(props.t('Must not include leading and trailing spaces'))
      .min(2, props.t("Too Short!"))
      .max(2000, props.t("Too Long!"))
      .required(props.t("Please enter negative impact")),
    comments: Yup.string()
      .strict(true)
      .trim(props.t('Must not include leading and trailing spaces'))
      .min(2, props.t("Too Short!"))
      .max(2000, props.t("Too Long!"))
      .nullable(),
    priority: Yup.object().shape({
      id: Yup.number().required(props.t("Please select priority")),
    }),
  });

  const formik = useFormik({
    initialValues: {
      ...newChangeRequestObject,
    },
    validationSchema: changeRequestValidation,
    validateOnMount: true,
    onSubmit: () => {
      handleCreate();
    },
  });

  const handleCreate = async (action) => {
    try {
      let changeRequestPayload = {
        projectId: props.setChangeRequestMetaInfo.projectId,
        description: formik.values.description,
        reason: formik.values.reason,
        impact: formik.values.impact,
        negativeImpact: formik.values.negativeImpact,
        ...(formik.values.comments &&
          formik.values.comments !== "" && {
            comments: formik.values.comments,
          }),
        priorityId: formik.values?.priority?.id,
      };

      setIsLoading(true);
      const response = await changeRequestUpdate(
        props.setChangeRequestMetaInfo?.id,
        changeRequestPayload
      );

      if (response.statusCode === 200) {
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (err) {
      toast.error(err.message);
      console.log("161=>", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Card className="customCard changeReqCard p-3 my-3">
        <div className="impact d-flex flex-column position-relative my-3">
          <label className="position-absolute abs-label">
            {props.t('Describe the change')} *
          </label>
          <TextareaAutosize
            className="position-relative"
            minRows="2"
            name="description"
            defaultValue={props?.setChangeRequestMetaInfo?.description}
            disabled={isLoading}
            value={formik.values.description}
            placeholder={props.t('Describe the change *')}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            required
          />
          {formik.touched.description && formik.errors.description && (
            <span className="text-danger">{formik.errors.description}</span>
          )}
        </div>
      {/* </Card> */}

      {/* <Card className="customCard changeReqCard p-3 my-3"> */}
        <div className="impact d-flex flex-column position-relative my-3">
          <label className="position-absolute abs-label">
          {props.t('Reason for the change')} *
          </label>
          <TextareaAutosize
            className="position-relative"
            minRows="2"
            name="reason"
            defaultValue={props?.setChangeRequestMetaInfo?.reason}
            disabled={isLoading}
            value={formik.values.reason}
            placeholder={props.t('Reason for the change *')}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            required
          />
          {formik.touched.reason && formik.errors.reason && (
            <span className="text-danger">{formik.errors.reason}</span>
          )}
        </div>
      {/* </Card> */}

      {/* <Card className="customCard changeReqCard p-3 my-3"> */}
        <div className="impact d-flex flex-column position-relative my-3">
          <label className="position-absolute abs-label">
          {props.t('Impact for the change')} *
          </label>
          <TextareaAutosize
            className="position-relative"
            minRows="2"
            name="impact"
            defaultValue={props?.setChangeRequestMetaInfo?.impact}
            disabled={isLoading}
            value={formik.values.impact}
            placeholder={props.t('Impact for the change *')}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            required
          />
          {formik.touched.impact && formik.errors.impact && (
            <span className="text-danger">{formik.errors.impact}</span>
          )}
        </div>
      {/* </Card> */}

      {/* <Card className="customCard changeReqCard priority-level my-3"> */}
      <div className=" my-3">
        <SearchDropDownListPaginationComponent
          label={props.t("Select Priority Level") + ' *'}
          required
          disabled={isLoading}
          defaultValue={formik.values?.priority}
          searchEnabled={false}
          listCall={AllPriorityList}
          emitItem={(newValue) => {
            setNewChangeRequestObject({
              ...newChangeRequestObject,
              priority: newValue,
            });
            formik.setFieldValue("priority", newValue ? newValue : "");
          }}
          onBlur={() => {
            if (!formik.touched?.priority) {
              formik.setFieldTouched("priority.id", true, true);
            }
          }}
        />
        {formik.touched.priority?.id && formik.errors.priority?.id && (
          <span className="text-danger">{formik.errors.priority.id}</span>
        )}
        </div>
      {/* </Card> */}

      {/* <Card className="customCard changeReqCard p-3 my-3"> */}
        <div className="impact d-flex flex-column position-relative my-3">
          <label className="position-absolute abs-label">
          {props.t('Specify the impact if the change request is not approved')} *
          </label>
          <TextareaAutosize
            className="position-relative"
            minRows="2"
            name="negativeImpact"
            defaultValue={props?.setChangeRequestMetaInfo?.negativeImpact}
            disabled={isLoading}
            value={formik.values.negativeImpact}
            placeholder={props.t('Specify the impact if the change request is not approved *')}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            required
          />
          {formik.touched.negativeImpact && formik.errors.negativeImpact && (
            <span className="text-danger">{formik.errors.negativeImpact}</span>
          )}
        </div>
      {/* </Card> */}

      {/* <Card className="customCard changeReqCard p-3 my-3"> */}
        <div className="commentBox d-flex w-100 my-3">
          <div>
            <UserProfile user={props.setChangeRequestMetaInfo?.creator} avatarClassName='me-2 ml-2' profileClassName='me-2 ml-2'/>
          </div>
          <div className="flex-grow-1">
            <TextEditor
              content={props?.setChangeRequestMetaInfo?.comments}
              toolbarId={`toolbarCreateComment`}
              placeholder={props.t("Others")}
              name="comments"
              isEmpty={false}
              disabled={isLoading}
              value={formik.values?.comments}
              emitItem={(newValue) => {
                const regex = /(<([^>]+)>)/gi;
                const newString = newValue.replace(regex, " ");
                formik.setFieldValue("comments", newValue ? newValue : "");
              }}
            />
          </div>
        </div>


      <div className="d-flex justify-content-center mt-2">
        <button
          className={`edit_button ${
            isLoading || !formik.isValid ? "bg-secondary" : ""
          }`}
          disabled={isLoading || !formik.isValid}
          onClick={formik.handleSubmit}
        >
          {isLoading && (
            <Spinner
              className="ml-1 me-2"
              type="border"
              color="light"
              size="sm"
            />
          )}
          {props.t('Update')}
        </button>
      </div>
      </Card>

    </div>
  );
}

export default withTranslation() (ChangeRequestMeta)
